export function getTimeStampYesterday() {
  const secondsInADay = 86400;
  return Math.round(Date.now() / 1000) - secondsInADay;
}
